exports.languages = [
    'en',
    'ar',
    'dk',
    'nl',
    'fr',
    'de',
    'it',
    'pt',
    'es',
    'se',
];



// WEBPACK FOOTER //
// ./src/constants/languages.js